import { Fragment } from 'react';
import { Box } from '@pocketlaw/tetris';
import { HtmlStringToReact } from 'app/domains/global-search/components/HtmlStringToReact';
import { getSearchHighlightContext } from 'app/domains/global-search/utils/getSearchHighlightContext';
import { StyledTypography } from './styled';
export function Match(props) {
    const { name, highlight } = props;
    const { highlightText, showNameOnly } = getSearchHighlightContext(name, highlight);
    return (<Box flexDirection="column" style={{ minWidth: 0 }}>
      {showNameOnly ? (<StyledTypography $truncate $fontSize="small" $appearance="300">
          <HtmlStringToReact allowedTags={['mark']} text={highlightText}/>
        </StyledTypography>) : (<Fragment>
          <StyledTypography $truncate $fontSize="small" $appearance="300">
            {name}
          </StyledTypography>
          <StyledTypography $truncate $appearance="100" $fontSize="tiny">
            … <HtmlStringToReact allowedTags={['mark']} text={highlightText}/> …
          </StyledTypography>
        </Fragment>)}
    </Box>);
}
